<template>
  <div class="footer">
    <span>Copyright: © 2020. All rights reserved.</span>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
    padding: 60px 20px 20px;
}
</style>
